import { useEffect, useState } from "react";
import api from "../../../../../../../services/api";
import { IItemHistorico } from "../../../../types";
import { ExpandedContent, Separator } from "./styles";
import { DadosCienciaProfissional } from "./types";
import BlocoPrincipal from "./Blocos/BlocoPrincipal";
import LogsVazio from "../../Compartilhado/LogsVazio";

interface ExpandedContentProps {
    item: IItemHistorico;
    onNavigateToFile?: (fileId: number) => void;
}

export default function ExpandedContentCienciaProfissional({ item }: ExpandedContentProps) {
    const [dados, setDados] = useState<DadosCienciaProfissional | null>(null);
    const [carregando, setCarregando] = useState(true);

    useEffect(() => {
        if (!item?.id) {
            setCarregando(false);
            setDados(null);
            return;
        }

        const carregarDados = async () => {
            setCarregando(true);

            try {
                const resposta = await api.get(`log-historico/${item.id}`);

                if (resposta.data.status === "success") {
                    const logs = resposta.data.result || [];
                    const logCiencia = logs.find((log: any) => log.entidade_nome === "orientacao");

                    if (logCiencia) {
                        setDados({
                            statusCienciaAntes: logCiencia.dados_antes?.status || "",
                            statusCienciaDepois: logCiencia.dados_depois?.status || ""
                        });
                    } else {
                        setDados(null);
                    }
                } else {
                    setDados(null);
                }
            } catch (_erro) {
                setDados(null);
            } finally {
                setCarregando(false);
            }
        };

        carregarDados();
    }, [item.id]);

    if (carregando) {
        return (
            <ExpandedContent>
                <div style={{ padding: "20px", textAlign: "center", color: "var(--c64748b)" }}>
                    Carregando dados...
                </div>
            </ExpandedContent>
        );
    }

    if (!dados) {
        return (
            <ExpandedContent>
                <Separator />
                <LogsVazio />
            </ExpandedContent>
        );
    }

    return (
        <ExpandedContent>
            <Separator />
            <BlocoPrincipal dados={dados} />
        </ExpandedContent>
    );
}


